/**
 * /dashboard/performance/goals — Legacy redirect. Goals list lives on
 * the Performance hub default (SOP §1.2).
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/goals/page.tsx
 * (Next.js server redirect → TanStack beforeLoad throw redirect).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/performance/goals/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/performance",
      params: { tenantSlug: params.tenantSlug },
    });
  },
});
